/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageRasterDto } from '../../models/page-raster-dto';
import { RasterFilterDto } from '../../models/raster-filter-dto';

export interface GetRastersFiltered$Params {

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;

/**
 * filter string
 */
  filter?: string;

/**
 * Get terser output with fewer fields filled in
 */
  terse?: boolean;
      body: RasterFilterDto
}

export function getRastersFiltered(http: HttpClient, rootUrl: string, params: GetRastersFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageRasterDto>> {
  const rb = new RequestBuilder(rootUrl, getRastersFiltered.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('filter', params.filter, {});
    rb.query('terse', params.terse, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageRasterDto>;
    })
  );
}

getRastersFiltered.PATH = '/v1/raster/search';
